const phoneText = "(41) 3082-0661";
const whatsappText = "(41) 98766-2501";
const whatsappLink = "https://wa.me/+5541987662501";

export { phoneText, whatsappText, whatsappLink };
